import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { ModalService } from '@app/@core/modal/modal.service';
import { SpinnerService } from '../spinner/spinner.service';
import { CustomDialogComponent } from '../modal/customDialog/customDialog.component';
import { UserService } from '@app/services/user.service';
import { Cognitive } from '@app/interface/survey';
@Component({
  selector: 'app-cognitive-table',
  templateUrl: './cognitive.component.html',
  styleUrls: ['./cognitive.component.scss'],
})
export class CognitiveComponent implements OnChanges {
  @Input() isLoading = false;
  @Input() message: string;
  @Input() dataTable: Cognitive[];
  @Input() dataColumn: string;
  first: number = 0;
  rows: number = 5;
  values = '';
  dialogRef: any;

  constructor(
    private modalService: ModalService,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    public userService: UserService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.dataTable && changes.dataColumn) {
      this.dataTable = changes.dataTable.currentValue;
      this.dataColumn = changes.dataColumn.currentValue;
    }
  }

  public getIndex(arr: any, cognitive: any) {
    let index = arr.map((item: any) => item.id).indexOf(cognitive['id']);
    return index;
  }

  public isLastPage(): boolean {
    return this.dataTable ? this.first === this.dataTable.length - this.rows : true;
  }

  public isFirstPage(): boolean {
    return this.dataTable ? this.first === 0 : true;
  }

  public deleteSurvey(cognitive: any): void {
    this.modalService
      .confirm('Are you sure that you want to remove ' + cognitive['name'])
      .pipe(take(1))
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.spinnerService.show();
          this.removeCognitive(cognitive);
        }
      });
  }

  public openEditForm(formData: any): void {
    this.modalService
      .custom(CustomDialogComponent, {
        title: 'Edit Cognitive',
        modalType: 'add-edit-cognitive',
        formType: 'Edit',
        formData: formData,
      })
      .pipe(take(1))
      .subscribe((result: any) => {
        if (result) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Survey is added succesfully.' });
        }
      });
  }

  public removeCognitive(cognitive: any): void {
    this.userService.deleteCognitive(cognitive.uuid).then(() => {
      this.spinnerService.hide();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: cognitive['cognitiveTestName'] + ' is deleted successfully',
      });
    });
  }
}
